module.exports = __webpack_public_path__ + "img/silo_img1.ccfc3461.jpeg";